module.exports = __webpack_public_path__ + "img/young-m2h.0cc8994c.png";